import React, { useEffect } from 'react';
import styles from './ReadMessage.module.scss';
import { useDispatch, useSelector } from 'react-redux';
// import {
//     getMessageDetails,
//     cleanMessageDetails,
//     pinMessage,
//     unpinMessage,
// } from '../../../../store/actions/messages';
import ModalHeading from '../../../Heading/Heading';
import ModalCloseButton from '../../../CloseButton/CloseButton';
import { getTranslation } from '../../../../../../utils/translation';
import {
    changeMessages,
    pinMessage,
    printMessage,
    unpinMessage,
} from '../../../../../../store/actions/messages';
import { showErrorNotification } from '../../../../../../utils/render';
import moment from 'moment';
import { changeUnreadMessageCount } from '../../../../../../store/actions/settings';

const ReadMessage = props => {
    const dispatch = useDispatch();
    const { isNewMessage } = useSelector(state => state.modals.messageModal);
    const currentMessage = useSelector(state => state.messages.messageDetails);
    const messagesList = useSelector(state => state.messages.messagesList);
    const messagesCount = useSelector(state => state.settings.account?.data?.messageCount);
    const accountNumber = useSelector(state => state.settings.account?.data?.accountNumber);

    useEffect(() => {
        if (currentMessage && Object.keys(currentMessage).length) {
            const newMessagesList = messagesList.map(msg => {
                if (msg.id === currentMessage.id) {
                    if (msg.messageStatus !== currentMessage.messageStatus) {
                        return { ...msg, messageStatus: currentMessage.messageStatus };
                    }
                }
                return msg;
            });
            dispatch(changeMessages(newMessagesList));

            if (isNewMessage) {
                dispatch(changeUnreadMessageCount(messagesCount - 1));
            }
        }
    }, [currentMessage]);

    const toggleMessagePin = () => {
        if (currentMessage.messageStatus === 2) {
            dispatch(unpinMessage(currentMessage.id));
        } else {
            dispatch(pinMessage(currentMessage.id));
        }
    };

    const onMessagePrint = async () => {
        try {
            const messageData = {
                messageId: currentMessage.id,
                cashierCode: accountNumber,
                subject: currentMessage.title,
                content: currentMessage.body,
                sent: moment(currentMessage.created).format('DD/MM/YYYY HH:mm:ss'),
                issueDate: moment().format('DD/MM/YYYY HH:mm:ss'),
            };
            printMessage(messageData);
        } catch (error) {
            console.error(error);
            showErrorNotification('Message print failed');
        }
    };

    const onClose = () => {
        props.closeModal(currentMessage.id);
    };

    return (
        currentMessage && (
            <>
                <ModalHeading
                    primary={`${getTranslation('messagesTableRowMoreModalMessageId')} ${
                        currentMessage.id
                    }`}
                    style={{}}
                >
                    <ModalCloseButton onClick={onClose} />
                </ModalHeading>
                <div className={styles.actions}>
                    <button
                        className={`${styles.actionBtn} ${
                            currentMessage?.messageStatus === 2 ? styles.pinButtonActive : ''
                        }`}
                        onClick={toggleMessagePin}
                    >
                        {getTranslation('messagesTableRowMoreModalSaveButton')}{' '}
                        <span className={`${styles.icon} icon-saved`} />
                    </button>
                    <button className={styles.actionBtn} onClick={onMessagePrint}>
                        {getTranslation('messagesTableRowMoreModalPrintButton')}{' '}
                        <span className={`${styles.icon} icon-printer`} />
                    </button>
                    {/*<button className={`${styles.actionBtn} m-l-auto m-r-0`}>*/}
                    {/*    Delete Message <span className='icon-trash' />*/}
                    {/*</button>*/}
                </div>
                <div className={styles.content}>
                    <div className={'flex justify-between'}>
                        <h4 className={styles.title}>{currentMessage.title}</h4>
                        <span className={styles.date}>
                            {moment(currentMessage.created).format('DD/MM/YYYY HH:mm:ss')}
                        </span>
                    </div>
                    <div className={styles.text}>{currentMessage.body}</div>
                </div>
            </>
        )
    );
};

export default ReadMessage;
